module.exports = __webpack_public_path__ + "static/media/document-icon.a88f74da.svg";